import { CognitoAuthProvider } from 'ra-auth-cognito'
import { CognitoUserPool } from 'amazon-cognito-identity-js'
import { isNil } from 'lodash/fp'
import { type AuthProvider } from 'react-admin'
import log from 'loglevel'

import cognito from '../../../../cdk/cognitoApi-v2/lib/lambda-api/src/clients/userPools.json'

log.setLevel(log.levels.DEBUG)

const env = process.env['ENV'] as string
const userPools = cognito[env as keyof typeof cognito]

export const cognitoAuthProvider = (
  partner: string
): AuthProvider | undefined => {
  const userPool = userPools[partner]
  if (isNil(userPool)) return undefined
  const { userPoolId: UserPoolId, clientId: ClientId } = userPool
  return CognitoAuthProvider(new CognitoUserPool({ UserPoolId, ClientId }))
}
